import React from 'react';
import { isChecked, valueEmpty, isSelected, formatMonth } from './uiFunctions';

export class InputRow extends React.Component {
	render() {
		let label = this.props.label;
		let placeholder = this.props.placeholder;
		let type = this.props.type;
		let value = this.props.value;
		let property = this.props.property;
		let disabled = this.props.disabled;
		let required = this.props.required;
		let options = this.props.options;
		let description = this.props.description;
		let rows = this.props.rows;
		let id = this.props.id;
		let className = this.props.className;
		let onChange = this.props.onChange;
		let max;
		let step = this.props.step;

		if (type === "date") {
			var year, month, day;
		    var today = new Date();

		    year = today.getFullYear();
		    month = formatMonth( today.getMonth()+1 );
		    day = formatMonth( today.getDate() );
		    var nowEndDate = year+"-"+month+"-"+day;
			max = nowEndDate;
		}

		
		return(
			<div className="input-row">

				{(label) && (
					<label htmlFor={property}>{label}</label>
				)}

				{(type === "checkbox" && !disabled) && (
					<div>
						<input type={type} name={property} defaultChecked={isChecked(value)} placeholder={label} id={id} onClick={onChange} />
					</div>
				)}
				{(type === "checkbox" && disabled) && (
					<div>
						<input type={type} name={property} defaultChecked={isChecked(value)} placeholder={label} id={id} disabled />
					</div>
				)}

				{((type === "date" || type === "color" || type === "password") && !disabled) && (
					<div>
						<input type={type} name={property} defaultValue={valueEmpty(value)} id={id} onChange={onChange} placeholder={label || placeholder} max={max} step={step} required={required} />
					</div>
				)}
				{((type === "number") && !disabled) && (
					<div>
						<input type={type} name={property} defaultValue={valueEmpty(value)} id={id} onChange={onChange} placeholder={label || placeholder} max={max} step={step} required={required} />
					</div>
				)}
				{((type === "date" || type === "number" || type === "color" || type === "password") && disabled) && (
					<div>
						<input type={type} name={property} defaultValue={valueEmpty(value)} id={id} onChange={onChange} placeholder={label} max={max} required={required} disabled />
					</div>
				)}

				{(type === "text" && !disabled) && (
					<div>
						<input
							type={type}
							name={property}
							defaultValue={valueEmpty(value)}
							placeholder={label || placeholder}
							id={id}
							onChange={onChange}
						/>
						{(description) && (
							<p>{description}</p>
						)}
					</div>
				)}
				{(type === "text" && disabled) && (
					<input
						type={type}
						name={property}
						defaultValue={valueEmpty(value)}
						placeholder={label}
						id={id}
						disabled
					/>
				)}

				{(type === "textarea") && (
					<div>
						<textarea
							name={property}
							defaultValue={valueEmpty(value)}
							placeholder={label}
							rows={rows}
							id={id}
						></textarea>
					</div>
				)}

				{(type === "select" && !disabled) && (
					<div className="select">
						<select id={id} name={property} onChange={onChange} className={className}>
							<option defaultValue selected disabled>Select...</option>
							{options.map((option, index) => 
								<option key={index} value={option.value} selected={isSelected(option.value, value)}>{option.name}</option>
							)}
						</select>
						<div className="select_arrow"></div>
					</div>
				)}
				{(type === "select" && disabled) && (
					<div className="select">
						<select id={id} name={property}  className={className} disabled>
							<option defaultValue disabled>Select...</option>
							{options.map((option, index) => 
								<option
									key={index} value={option.value} selected={isSelected(option.value, value)}>{option.name}</option>
							)}
						</select>
					</div>
				)}

			</div>
		)
	}
}